import { AppBar, Button, Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import CompanySelector from './CompanySelector'
import LanguagePicker from './LanguagePicker'
import ProfileMenu from './ProfileMenu'
import ThemeModePicker from './ThemeModePicker'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  displayPrint: 'none',
  '& .MuiButton-root': {
    color: 'inherit',
  },
  '& .MuiIconButton-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-input': {
    color: 'inherit',
  },
  '& .MuiSelect-icon': {
    color: 'inherit',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
  '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
}))

const AppHeader = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <StyledAppBar position="static" color="secondary">
      <Toolbar>
        <Button href="/" sx={{ flexShrink: 0, mr: 2 }}>
          <img src="/images/iFinance-white.svg" alt="Iceberg Finance" style={{ width: '110px', height: '40px' }} />
        </Button>
        <span style={{ flexGrow: 1 }}>&nbsp;</span>
        <Button href="/reports/classification">{t('reports.reports')}</Button>
        <CompanySelector />
        <ProfileMenu />
        <LanguagePicker />
        <ThemeModePicker />
      </Toolbar>
    </StyledAppBar>
  )
}

export default AppHeader
